export enum REACTIONS_REACT {
    /**
     * @value Users who like this
     */
    USER_LIST_LIKES = 'USER_LIST_LIKES',
}
